<script lang="ts">
  export let color: string = 'stroke-gray-950';
</script>

<svg class={color} xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none"
  ><path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.6666"
    d="M10.5 3 5 8.5 2.5 6"
  /></svg
>
